<kv-loyalty-info-customers-filter (onApply)="onSearch($event)" ></kv-loyalty-info-customers-filter>

  <div class="ui-g ui-g-12">
    <app-kontable #table
      *ngIf="searchPressed"
      title="{{ 'loyalty.info_customers' | translate }}"
      [columns]="[
                  'card_no',
                  'name',
                  'surname',
                  'cluster',
                  'email',
                  'mobile',
                  'telephone',
                  'birth_date',
                  'city',
                  'address_1',
                  'address_no',
                  'zip_code',
                  'province_code',
                  {field: 'flg_blk_lst', title: 'loyalty.flg_blk_lst',  bodyTemplate: blacklistTemplate, filterType: customFilter, filterTemplate: customerBlacklistFilter}
                ]"
      [titles]="[
                  'loyalty.card_no',
                  'loyalty.name',
                  'loyalty.surname',
                  'loyalty.cluster',
                  'loyalty.email',
                  'loyalty.mobile',
                  'loyalty.telephone',
                  'loyalty.birth_date',
                  'loyalty.city',
                  'loyalty.address_1',
                  'loyalty.address_no',
                  'loyalty.zip_code',
                  'loyalty.province_code'
                ]"
      [reportColumnWidth]="[100, 90, 100, 65, 120, 80, 90, 80, 120, 100, 40, 50, 40, 25]"
      [reportColumnType]="['STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD','STANDARD']"
      [reportColumnAlignment]="['center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center', 'center']"
      [isReportHor] = 'true'
      [source]="infoCustomersList"
      [showGlobalFilter]="false"
      [showDetailsButton]="false"
      [showInfoButton]="false"
      [showRecoverButton]="false"
      [showAddButton]="false"
      [showEditButton]="false"
      [showDeleteButton]="false"
      [additionalRowCommands]="customActions"
      [paginationType]="paginationType"
    >

    <ng-template #blacklistTemplate data-testid="blacklistTemplate" let-row class="deleted-row">
      <span *ngIf="row.flg_blk_lst != '1'">{{'card.active' | translate}}</span>
      <span *ngIf="row.flg_blk_lst && row.flg_blk_lst == '1'">{{'card.blacklist' | translate}}</span>
    </ng-template>

    <ng-template #customerBlacklistFilter data-testid="customerBlacklistFilter" let-col>
      <p-dropdown [options]="listBlacklist" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
    </ng-template>

    <ng-template #customActions data-testid="customActions" let-row>
      <p-button *ngIf="!!row['customerCode']" pTooltip="{{ 'customers.title' | translate }}" icon="fa fas fa-user"  styleClass="ui-button-info" (onClick)="onClickCustomer(row['customerCode'], row['card_no'])"></p-button>
    </ng-template>

    </app-kontable>

  </div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-info-customers/loyalty-info-customers.component.html